import React, { useEffect, useState } from 'react';
import './wsPanelList.style.scss';
import { Form, ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import HeaderAndSidebar from 'ucheck/components/HAS/HAS.index';
import WorkspaceList from './wsList/wsList.index';
import WorkspaceListSkeleton from './wsList/wsList.skeleton';
import { Button } from '@material-ui/core';
import FormCard, { FormCardProps } from 'ucheck/components/formCard/formCard.index';
import { WSData } from 'scripts/storage';
import PublishCard from './forms/card/formCard.index';
import { getFormAnswersCount } from 'scripts/db';
import { MessageBridge } from 'scripts/messageBridge';

const WorkspacePanel: React.FC<ConnectedProps<typeof connector> & { onRefresh: () => Promise<boolean> }> = function (
    props: ConnectedProps<typeof connector> & { onRefresh: () => Promise<boolean> },
) {
    const lang = props.lang.wsPanel.panel;
    const [toggle, setToggle] = useState<'favForms' | 'questionerForms'>(
        props.workspaces?.length === 0 && props.allPublishes?.length ? 'questionerForms' : 'favForms',
    );
    const [favForms, setFavForms] = useState<FormCardProps[]>();

    useEffect(() => {
        const data = WSData.get();
        if (data) {
            const forms: FormCardProps[] = [];
            const allForms: Form[] = [];
            const promises: Promise<any>[] = [];
            data.map((item) =>
                item.forms.map((i) => {
                    promises.push(getFormAnswersCount(i.id));
                    allForms.push(i);
                }),
            );
            Promise.all(promises).then((res: number[]) => {
                res.map((i, index) => {
                    if (props.user?.favorite_forms.includes(allForms[index].id))
                        forms.push({ form: allForms[index], answerCount: i });
                });
                setFavForms([...forms]);
            });
        }
        MessageBridge.message('BACK_BUTTON_ROOT_STATUS', true);
        return () => {
            MessageBridge.message('BACK_BUTTON_ROOT_STATUS', false);
        };
    }, [props.workspaces]);

    return (
        <div className="ucheck-kiosk-ws-panel">
            <HeaderAndSidebar onRefresh={props.onRefresh} />
            {props.expire ? (
                <p className="expire-error">
                    کاربر محترم به منظور فعالسازی مجدد بروزرسانی فرم ها و فضای های کاری لطفا یک بار از حساب کاربری خود
                    خارج و مجددا وارد شوید.
                </p>
            ) : null}
            <div className="ws-list">
                <h2>{lang.wss}</h2>
                {props.workspaces ? <WorkspaceList /> : <WorkspaceListSkeleton />}
            </div>
            <div className="forms-list d-flex flex-column">
                <div className="d-flex align-items-center forms-list-header">
                    <Button
                        onClick={() => setToggle('favForms')}
                        className={`${toggle === 'favForms' ? 'active' : ''}`}
                    >
                        {lang.favForms}
                    </Button>
                    <Button
                        onClick={() => setToggle('questionerForms')}
                        className={`${toggle === 'questionerForms' ? 'active' : ''}`}
                    >
                        {lang.questionerPublishes}
                    </Button>
                </div>
                <div className="form-list-content">
                    {toggle === 'favForms' ? (
                        favForms && props.workspaces ? (
                            favForms.length ? (
                                favForms.map((i, index) => {
                                    if (index < 5) return <FormCard key={index} {...i} />;
                                })
                            ) : (
                                <p className={`${props.workspaces.length ? '' : 'd-none'}`}>{lang.emptyStateForm}</p>
                            )
                        ) : (
                            <>
                                <FormCard />
                                <FormCard />
                                <FormCard />
                                <FormCard />
                                <FormCard />
                            </>
                        )
                    ) : props.allPublishes !== null ? (
                        props.allPublishes.map((i, index) => <PublishCard key={index} data={i} />)
                    ) : (
                        <>
                            <FormCard />
                            <FormCard />
                            <FormCard />
                            <FormCard />
                            <FormCard />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
    publishDetail: state.publishData,
    allPublishes: state.publishesData,
    workspaces: state.workspacesData,
    expire: state.expired,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(WorkspacePanel);
